import * as Yup from "yup";

export function initialValues(quiz) {
  return {
    name: quiz?.name || "",
    description: quiz?.description || "",
  };
}

export function validationSchema() {
  return Yup.object({
    name: Yup.string().required("El nombre es requerido"),
    description: Yup.string().required("La descripción es requerida"),
  });
}
